import dayjs from 'dayjs'

export const isBeforeNow = (date?: string) => {
  if (!date) return true

  return dayjs() < dayjs(date)
}
